import {
    QidModel,
    QidModelSafetyFunction,
    QidModelOption,
    QidModelFailureMode,
} from "server/models"
import { PublishedUnpublished, OrderType, QidType, ProvenType } from "client/utils"

export interface QidModelList { [modelId: number]: QidModel }
export interface QidModelFilters {
    name?: string
    type?: QidType
    lowDemandMode?: boolean
    highDemandMode?: boolean
    continuousMode?: boolean
    logicSolver?: boolean
    provenInUse?: ProvenType
    status?: PublishedUnpublished
    search?: string
}

export type QidModelValidation = { [key in keyof QidModel]?: string }
export type QidModelSafetyFunctionValidation = { [key in keyof QidModelSafetyFunction]?: string }
export type QidModelOptionValidation = { [key in keyof QidModelOption]?: string }
export type QidModelFailureModeValidation = { [key in keyof QidModelFailureMode]?: string }

export interface QidModelState {
    modelList: QidModelList
    modelIds: readonly number[]

    expandedModelIds: readonly number[]
    expandedSafetyFunctionIds: readonly number[]

    sortColumn: keyof QidModel
    sortOrder: OrderType
    filters: QidModelFilters

    changeStatusModel: QidModel

    editModel: QidModel
    editSafetyFunction: QidModelSafetyFunction
    editOption: QidModelOption
    editFailureMode: QidModelFailureMode

    deleteModel: QidModel
    deleteSafetyFunction: QidModelSafetyFunction
    deleteOption: QidModelOption
    deleteFailureMode: QidModelFailureMode

    reloadList: boolean
    reloadEditModel: boolean
    reloadEditSafetyFunction: boolean
}

export const QID_MODEL_LIST = "QID_MODEL_LIST"
export const QID_MODEL_IDS = "QID_MODEL_IDS"

export const QID_MODEL_EXPANDED_MODEL_IDS = "QID_MODEL_EXPANDED_MODEL_IDS"
export const QID_MODEL_EXPANDED_SAFETY_FUNCTION_IDS = "QID_MODEL_EXPANDED_SAFETY_FUNCTION_IDS"

export const QID_MODEL_SORT = "QID_MODEL_SORT"
export const QID_MODEL_FILTERS = "QID_MODEL_FILTERS"

export const QID_MODEL_CHANGE_STATUS_MODEL = "QID_MODEL_CHANGE_STATUS_MODEL"

export const QID_MODEL_EDIT_MODEL = "QID_MODEL_EDIT_MODEL"
export const QID_MODEL_EDIT_SAFETY_FUNCTION = "QID_MODEL_EDIT_SAFETY_FUNCTION"
export const QID_MODEL_EDIT_OPTION = "QID_MODEL_EDIT_OPTION"
export const QID_MODEL_EDIT_FAILURE_MODE = "QID_MODEL_EDIT_FAILURE_MODE"

export const QID_MODEL_DELETE_MODEL = "QID_MODEL_DELETE_MODEL"
export const QID_MODEL_DELETE_SAFETY_FUNCTION = "QID_MODEL_DELETE_SAFETY_FUNCTION"
export const QID_MODEL_DELETE_OPTION = "QID_MODEL_DELETE_OPTION"
export const QID_MODEL_DELETE_FAILURE_MODE = "QID_MODEL_DELETE_FAILURE_MODE"

export const QID_MODEL_RELOAD_LIST = "QID_MODEL_RELOAD_LIST"
export const QID_MODEL_RELOAD_EDIT_MODEL = "QID_MODEL_RELOAD_EDIT_MODEL"
export const QID_MODEL_RELOAD_EDIT_SAFETY_FUNCTION = "QID_MODEL_RELOAD_EDIT_SAFETY_FUNCTION"
